import { ItemView } from '@glu/core';

import template from './messageRow.hbs';

export default ItemView.extend({
  tagName: 'tr',
  template,

  templateHelpers() {
    return {
      ifPlural(length) {
        return (length > 1) ? 's' : null;
      },
      colspan: this.options.colspan
    };
  }
});
